import React, { useState } from "react";
import { UilSearch, UilLocationPoint } from "@iconscout/react-unicons";
import { toast } from "react-toastify";

function Inputs({ setQuery, units, setUnits }) {
  const [city, setCity] = useState("");

  const handleUnitsChange = (e) => {
    const selectedUnit = e.currentTarget.name;
    if (units !== selectedUnit) setUnits(selectedUnit);
  };

  const handleSearchClick = () => {
    if (city !== "") setQuery({ q: city });
  };

  const handleLocationClick = () => {
    if (navigator.geolocation) {
      toast.info("Fetching users location.");
      navigator.geolocation.getCurrentPosition((position) => {
        toast.success("Location fetched!");
        let lat = position.coords.latitude;
        let lon = position.coords.longitude;

        setQuery({
          lat,
          lon,
        });
      });
    }
  };

  return (
    <div className="flex flex-row justify-center my-6">
      <div className="sm:flex sm:flex-row sm:w-3/4 sm:items-center sm:justify-center sm:space-x-4 md:flex md:flex-row md:w-3/4 md:items-center md:justify-center md:space-x-4 lg:flex lg:flex-row lg:w-3/4 lg:items-center lg:justify-center lg:space-x-4 flex flex-col w-3/4 items-center justify-center">
        <input
          value={city}
          onChange={(e) => setCity(e.currentTarget.value)}
          type="text"
          placeholder="Search for city...."
          className="text-sm font-light  p-2 m-2 w-30 sm:text-xl sm:font-light sm:p-2 sm:w-full md:text-xl md:font-light md:p-2 md:w-full lg:text-xl lg:font-light lg:p-2 lg:w-full shadow-xl focus:outline-none capitalize placeholder:lowercase"
        />
        <UilSearch
          size={30}
          className="text-white cursor-pointer m-2 transition ease-out hover:scale-125"
          onClick={handleSearchClick}
        />
        <UilLocationPoint
          size={30}
          className="text-white cursor-pointer m-2 transition ease-out hover:scale-125"
          onClick={handleLocationClick}
        />
      </div>

      <div className="flex flex-row w-1/4 items-center justify-center">
        <button
          name="metric"
          className="text-xl text-white font-light transition ease-out hover:scale-125"
          onClick={handleUnitsChange}
        >
          °C
        </button>
        <p className="text-xl text-white mx-1">|</p>
        <button
          name="imperial"
          className="text-xl text-white font-light transition ease-out hover:scale-125"
          onClick={handleUnitsChange}
        >
          °F
        </button>
      </div>
    </div>
  );
}

export default Inputs;

// import React from 'react';
// import { UilSearchAlt, UilLocationPoint } from '@iconscout/react-unicons';

// function Inputs() {
//   return (
//     <div className='flex flex-row justify-center my-6'>
//         <div className='flex flex-row w-3/4 items-center justify-center space-x-4'>
//             <input type="text" 
//             placeholder='Search for location....'
//             className='text-xl font-light p-2 w-full shadow-xl focus:outline-none capitalize placeholder:lowercase'
//             />
//             <UilSearchAlt 
//             size={25} 
//             className="text-white cursor-pointer transition ease-out hover:scale-125"/>
//             <UilLocationPoint 
//             size={25} 
//             className="text-white cursor-pointer transition ease-out hover:scale-125"/>
//         </div>

//         <div className='flex flex-row w-1/4 items-center justify-center'>
//             <button name="metric" className="text-xl text-white font-light">°C</button>
//             <p className='text-xl text-white mx-1'>|</p>
//             <button name="imperial" className="text-xl text-white font-light">°F</button>
//         </div>
//   </div>
//   )
// }

// export default Inputs;